import SearchDollarIcon from "@/components/SearchDollarIcon";

// OzyLoans logo mark: red rounded-square with white magnifier-$ inside.
export const OzyLogoMark = ({ className = "w-8 h-8", radiusClass = "rounded-lg", ...props }) => (
  <span
    className={`inline-flex items-center justify-center ${radiusClass} bg-[#E50914] ${className}`}
    {...props}
  >
    <SearchDollarIcon className="w-3/5 h-3/5 text-black" />
  </span>
);

export default OzyLogoMark;
